import { createApp } from 'vue';
import { safeDefine } from '@breuni-ui/safe-define';
import vueDataVueComponent from './vueData.vue.component.js';
import '../../scripts/lib/EventBus.js';
import { readJsonFromDom } from '../../scripts/utils.js';

class BewertenVueData extends HTMLElement {
  connectedCallback() {
    const appRoot = document.querySelector('#ents-vue-pds') as HTMLElement;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const productJSON = readJsonFromDom('#entsProductData') as any;
    const { syan, articles, articleKey: initialKey } = productJSON;
    const productDetailsJSON = readJsonFromDom('#entsProductDetailData');
    const eventTrackingJSON = readJsonFromDom('#entsEventTrackingData');
    const metaLanguageJSON = readJsonFromDom('#entsLanguageMetaData');
    const {
      mandatedHost,
      wishlistApiTimeout: rawWishlistApiTimeout,
      fitaRecoCall: rawFitaRecocall,
      showChristmasBear: rawShowChristmasBear,
      isBreuningerReferrer: rawIsBreuningerReferrer,
    } = this.dataset;
    const wishlistApiTimeout = Number.parseInt(rawWishlistApiTimeout as string, 10);
    const fitaRecoCall = rawFitaRecocall === 'true';
    const showChristmasBear = rawShowChristmasBear === 'true';
    const isBreuningerReferrer = rawIsBreuningerReferrer === 'true';

    const app = createApp(
      vueDataVueComponent({
        syan,
        articles,
        initialKey,
        productJSON,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        productDetailsJSON: productDetailsJSON as any,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventTrackingJSON: eventTrackingJSON as any,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        metaLanguageJSON: metaLanguageJSON as any,
        appRoot,
        mandatedHost: mandatedHost as string,
        wishlistApiTimeout,
        fitaRecoCall,
        showChristmasBear,
        isBreuningerReferrer,
      }),
    );

    // configureCompat({ RENDER_FUNCTION: false, COMPILER_INLINE_TEMPLATE: true });
    app.config.compilerOptions.whitespace = 'preserve';
    app.config.compilerOptions.delimiters = ['[[', ']]'];
    app.config.compilerOptions.isCustomElement = (tag) =>
      /^shop-|^bewerten-|^ents-|^suchen-|^kaufen-|^entd-|^brtn-|^camp-|^reco-|^additional-price-info|^loyl-/.test(tag);

    app.mount(appRoot);
  }
}

safeDefine('ents-vue-data', BewertenVueData);
